import React from 'react';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableWrapper,
} from '../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface PositionsTableSkeletonProps {
  isLoading?: boolean;
  isEmbeddedMobile: boolean;
}

export const PositionsTableSkeleton: React.FC<PositionsTableSkeletonProps> = ({
  isLoading,
  isEmbeddedMobile,
  children,
}) => {
  return (
    <Card mt="16">
      {!isEmbeddedMobile && (
        <Text variant="cardTitle" px="16" pt="12" pb="4">
          Allocation
        </Text>
      )}

      <Box px="16" pt="12" pb="24">
        {isLoading ? (
          <Shimmer height={32} width="100%" />
        ) : (
          <Box width="100%" height={32} borderRadius="medium" bg="neutral.200" />
        )}
      </Box>

      <TableWrapper variant="embedded">
        <TableHeader>
          <TableRow>
            <TableCell width="100%">&nbsp;</TableCell>
          </TableRow>
        </TableHeader>

        <TableBody>{children}</TableBody>
      </TableWrapper>
    </Card>
  );
};
